class MobileCarouselNav extends HTMLElement {
  connectedCallback() {
    // Support both the original .custom-section-content wrapper and
    // the newer .mobile-carousel-wrapper used by the multicolumn section.
    const wrapper =
      this.closest('.custom-section-content') ||
      this.closest('.mobile-carousel-wrapper');

    this.carousel = wrapper?.querySelector('.mobile-carousel');
    if (!this.carousel) return;

    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');
    this.currentEl = this.querySelector('[data-current]');
    this.totalEl = this.querySelector('[data-total]');

    if (this.totalEl) {
      this.totalEl.textContent = this.carousel.children.length;
    }

    this.prevBtn?.addEventListener('click', () => this.scrollSlide(-1));
    this.nextBtn?.addEventListener('click', () => this.scrollSlide(1));

    this.handleScroll = () => this.updateState();
    this.carousel.addEventListener('scroll', this.handleScroll, { passive: true });

    this.resizeObserver = new ResizeObserver(() => this.updateState());
    this.resizeObserver.observe(this.carousel);

    this.updateState();
    requestAnimationFrame(() => this.updateState());
  }

  disconnectedCallback() {
    this.carousel?.removeEventListener('scroll', this.handleScroll);
    this.resizeObserver?.disconnect();
  }

  scrollSlide(direction) {
    const item = this.carousel.firstElementChild;
    if (!item) return;
    const gap = parseFloat(getComputedStyle(this.carousel).gap) || 0;
    const slideWidth = item.getBoundingClientRect().width + gap;
    this.carousel.scrollBy({ left: direction * slideWidth, behavior: 'smooth' });
  }

  updateState() {
    const { scrollLeft, scrollWidth, offsetWidth } = this.carousel;

    if (this.prevBtn) this.prevBtn.disabled = scrollLeft <= 1;
    if (this.nextBtn) this.nextBtn.disabled = scrollLeft + offsetWidth >= scrollWidth - 1;

    if (this.currentEl) {
      const item = this.carousel.firstElementChild;
      if (item) {
        const gap = parseFloat(getComputedStyle(this.carousel).gap) || 0;
        const slideWidth = item.getBoundingClientRect().width + gap;
        const current = slideWidth > 0 ? Math.round(scrollLeft / slideWidth) + 1 : 1;
        this.currentEl.textContent = Math.min(current, this.carousel.children.length);
      }
    }
  }
}

if (!customElements.get('mobile-carousel-nav')) {
  customElements.define('mobile-carousel-nav', MobileCarouselNav);
}
